var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Timeouts } from '../framework/Timeouts';
export class VaddioCamera {
    constructor(socket, log) {
        this.socket = socket;
        this.pan = 0;
        this.tilt = 0;
        this.zoom = 1;
        this.power = false;
        this.apiState = 'username';
        this.timeouts = new Timeouts();
        this.apiAsyncHandlers = [
            {
                name: 'version',
                regExp: /version/i,
                callback: (match) => {
                    this.socket.send(`System Version RoboSHOT 1.0`);
                },
            },
            {
                name: 'power',
                regExp: /camera standby (on|off|get)/i,
                callback: (match) => {
                    if (match[1].toLowerCase() !== 'get') {
                        this.power = match[1].toLowerCase() === 'off';
                        this.socket.send(`OK`);
                    }
                    else {
                        this.socket.send(`standby: ${this.power ? 'off' : 'on'}`);
                    }
                },
            },
            {
                name: 'pan',
                regExp: /camera pan (get|left|right|stop|set)\s*([\d\.]*)/i,
                callback: (match) => {
                    const cmd = match[1].toLowerCase();
                    if (cmd === 'get') {
                        this.socket.send(`${this.pan}`);
                    }
                    else if (cmd === 'set' && match[2]) {
                        this.pan = parseFloat(match[2]);
                    }
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'tilt',
                regExp: /camera tilt (get|up|down|stop|set)\s*([\d\.]*)/i,
                callback: (match) => {
                    const cmd = match[1].toLowerCase();
                    if (cmd === 'get') {
                        this.socket.send(`${this.tilt}`);
                    }
                    else if (cmd === 'set' && match[2]) {
                        this.tilt = parseFloat(match[2]);
                    }
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'zoom',
                regExp: /camera zoom (get|in|out|stop|set)\s*([\d\.]*)/i,
                callback: (match) => {
                    const cmd = match[1].toLowerCase();
                    if (cmd === 'get') {
                        this.socket.send(`${this.zoom}`);
                    }
                    else if (cmd === 'set' && match[2]) {
                        this.zoom = parseInt(match[2], 10);
                    }
                    this.socket.send(`OK`);
                },
            },
            {
                name: 'invalid',
                regExp: /.+/i,
                callback: (match) => {
                    this.socket.send(`Syntax error: Unknown or incomplete command`);
                },
            },
        ];
        this.authAsyncHandlers = [
            {
                regExp: /.+/i,
                callback: (match) => __awaiter(this, void 0, void 0, function* () {
                    if (this.apiState === 'username') {
                        this.apiState = 'password';
                        this.socket.sendRaw(`Password: `);
                    }
                    else if (this.apiState === 'password') {
                        yield this.timeouts.delay(1000);
                        this.apiState = 'authenticated';
                        const welcomeMessage = this.createWelcomeResponse();
                        welcomeMessage.forEach(resp => {
                            this.socket.send(resp);
                        });
                        this.asyncHandlers = this.apiAsyncHandlers;
                    }
                }),
            },
        ];
        this.asyncHandlers = this.authAsyncHandlers;
    }
    onInitialize() {
        return __awaiter(this, void 0, void 0, function* () {
            this.apiState = 'username';
            this.asyncHandlers = this.authAsyncHandlers;
            yield this.timeouts.delay(1000);
            this.socket.sendRaw(`Login: `);
        });
    }
    createWelcomeResponse() {
        const retValue = [];
        retValue.push(`Last login: Wed Mar 30 13:19:52\r`);
        retValue.push(`*************************************`);
        retValue.push(`*     Vaddio Interactive Shell      *`);
        retValue.push(`*                                   *`);
        retValue.push(`*  WARNING: Authorized Access Only  *`);
        retValue.push(`*************************************\r`);
        retValue.push(`Welcome admin\r`);
        return retValue;
    }
}
VaddioCamera.emulatorType = 'socketEmulator';
VaddioCamera.key = '-NQB4XlzfVDZvy8eXZKD';
